import React from "react";
import "../css/returns.scss";
import { Link } from "react-router-dom";

const toTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

function Returns() {
  return (
    <main className="layout--template" id="main_content">
      <div className="shopify-policy__container">
        <div className="shopify-policy__title">
          <h1>Refund policy</h1>
        </div>
        <div className="shopify-policy__body">
          <div className="rte">
            <p>
              <strong>
                To start a return or exchange, click{" "}
                <Link onClick={toTop} to="/">
                  here
                </Link>
                .
              </strong>
            </p>
            <p>
              <strong>RETURNS: </strong>Our return policy deadline is 30 days.
              If 30 days have passed since your purchase, unfortunately, we
              can't give a refund or exchange. To be eligible for a return, your
              unused and in the same condition when received, and must be in the
              original packaging.&nbsp;&nbsp;
            </p>
            <ul>
              <li>
                <strong>NOTE: </strong>If your item is a perishable (tea,
                coffee, chocolate,etc.) The original seal must be intact and
                unbroken to be eligible for a return.&nbsp;
              </li>
              <li>
                <strong>Gift cards</strong>
                <span>&nbsp;</span>are non-returnable items.
              </li>
              <li>
                <strong>Sale Items</strong> are non-returnable items.
              </li>
            </ul>
            <p>
              <strong>
                If you are notified that your package is 'delivered' but have
                not received it, please allow for 1-3 days for delivery before
                filing a claim to see if the item arrives.{" "}
              </strong>
              If you still need to file a claim, if you opted for
              package protection at checkout, we will process your
              return immediately. If you opted out, we will process your
              exchange or return once the claim has been processed by the
              shipper (14-20 days).
            </p>
            <p>
              For items that are received damaged or broken, please immediately
              file a claim through our{" "}
              <Link onClick={toTop} to="/">
                claims portal
              </Link>{" "}
              and save all the packaging material. We will contact the shipping
              company, file a claim, and replace the item - if available - at no
              cost to you.
            </p>
            <p>=</p>
            <p>
              <strong>REFUNDS</strong>&nbsp;(if applicable): Once your return is
              received and inspected, we will send to you an email notifying
              that we have received your returned item and regarding the&nbsp;
              approval or rejection of your refund.&nbsp;If you are approved, we
              will replace the item, or process a full refund based upon your
              request.
            </p>
            <p>
              <strong>LATE or MISSING REFUNDS:&nbsp;</strong>If you haven't
              received a refund within a reasonable amount of time, first check
              your bank account.&nbsp;If the refund is through a credit card,
              contact your credit card company, it may take some time before
              your refund is officially posted.&nbsp;
            </p>
            <p>
              If you've done all of this and still have not received your
              refund, please contact us:&nbsp;
              <Link onClick={toTop} to="mailto:steps@tugglefield.xyz">
                steps@tugglefield.xyz
              </Link>
            </p>
            <p>
              <strong>GIFTS:&nbsp;</strong>If the item was a gift for you from
              someone else, and shipped directly to you, you'll receive a gift
              credit for the value of your return. Once the returned item is
              received, a gift certificate will be mailed to you.
              <br />
              <br />
              If the item wasn't marked as a gift when purchased, or the gift
              giver had the order shipped to themselves to give to you later, we
              will send a refund to the gift giver and he will find out about
              your return.
              <br />
              <br />
              <strong>SHIPPING:&nbsp;</strong>To return your product, please use
              the label provided through our returns portal.
            </p>
            <p className="p1">
              If you selected return package protection, your return shipping label is
              included, allowing you to return any item(s) in your order for a
              refund or exchange for free! Return requests should be submitted
              through our customer portal.
            </p>
            <p className="p1">
              If you did not select return package protection, you are still able to
              submit your return through our portal. However, you are
              responsible for all return shipping charges. Return labels should
              be purchased through our customer portal.&nbsp;
            </p>
          </div>
        </div>
      </div>
    </main>
  );
}

export default Returns;
